import { TemplateStepParamKey } from '@/features/templates'

export const ParametersTypesOptions: Array<{ label: string; value: TemplateStepParamKey }> = [
  {
    label: 'Zendesk ticket field',
    value: 'zendesk_ticket_field',
  },
  {
    label: 'Zendesk lookup ticket field',
    value: 'zendesk_ticket_field_lookup',
  },
  {
    label: 'Zendesk custom object key',
    value: 'zendesk_custom_object_key',
  },
  {
    label: 'Zendesk custom object field(should be after Zendesk custom object key parameter)',
    value: 'zendesk_custom_object_field',
  },
  {
    label: 'Templates - Slack notifications - Views config',
    value: 'template_slack_notifications_views_config',
  },
]
